"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const BaseModel_1 = tslib_1.__importDefault(require("./BaseModel"));
const createTag_graphql_1 = tslib_1.__importDefault(require("../gql/tags/mutations/createTag.graphql"));
const deleteTag_graphql_1 = tslib_1.__importDefault(require("../gql/tags/mutations/deleteTag.graphql"));
class Tag extends BaseModel_1.default {
    constructor() {
        super(...arguments);
        this.createMutation = createTag_graphql_1.default;
    }
    defaults() {
        return {
            uuid: '',
            name: '',
        };
    }
    delete() {
        const _super = Object.create(null, {
            delete: { get: () => super.delete }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return _super.delete.call(this, deleteTag_graphql_1.default);
        });
    }
}
exports.default = Tag;
//# sourceMappingURL=Tag.js.map